import { FC, useCallback, useEffect, useState } from "react";
import Header from "@/components/header";
import Slider from "@/components/slide";
import Category from "@/components/category";
import VipCard from "./vipCard";
import BannerList from "./bannerList";
import u from "@/util";
import RelateList from "./relateList";
import FastSection from "./fastSection";
import MsgModal from "@/components/modal/msgModa";
import Download from "@/components/download";
import layoutStyles from "@/components/styles/layout.module.css"
import styles from "@/components/styles/categoryHead.module.css"  
import useConfBase from "@/hooks/useConfBase";
import useAxios from "@/hooks/useAxios";
import Img from "./img";
// import FloatLR from "./floatLR";


interface ICategoryHead {
    showCategory?: boolean;
    children?: React.ReactNode;
    hideHead?: boolean;
    flag?: 0 | 1,
    hideAds?: boolean
}


const CategoryHead: FC<ICategoryHead> = ({ showCategory, children, hideHead, flag, hideAds }) => {
    const [isScroll, setIsScroll] = useState<number>(0)
    const [config, updateConfBase, getData] = useConfBase();
    const [expandedItemId, setExpandedItemId] = useState<number | null>(null);
    const onScroll = () => setIsScroll(window.pageYOffset);
    const [siteCili, setSiteCili] = useState<"1" | "0">("0")
    const [siteTopic, setSiteTopic] = useState<"1" | "0">("0")
    const { req } = useAxios("index/statistics", 'post', true);
    const [PostBarMM, setPostBarMM] = useState<any>()
    const [error, setError] = useState<string | null>(null);   // Store error if any



    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 600); // Set true if screen width is 768px or less (mobile)
    };

    useEffect(() => {
        // Add event listener to track window size changes
        window.addEventListener('resize', handleResize);

        // Initial check for screen size when the component mounts
        handleResize();

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const sourcurl = process.env.REACT_APP_STATIC_POSTBAR_MM_SRC;



    useEffect(() => {
        const fetchPostBarMM = async () => {
            try {
                const result = await u.getPostBarMM(sourcurl,)
                setPostBarMM(result);
            } catch (err) {
                setError('Failed to fetch comments.');
            }
        };

        fetchPostBarMM();
    }, [sourcurl])

    useEffect(() => {
        setSiteCili(config?.site_cili || "0")
        setSiteTopic(config?.site_topic ?? "1")
    }, [config])

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
        }
    }, []);

    const getAddiotionalHideCondition = useCallback(() => {
        if (u.isPermenantVip()) {
            return false;
        }
        if (u.hideAdsOnCertainPages()) {
            return false;
        }
        if (!hideAds === false) {
            return false
        }
        return true
    }, [hideAds])

    const cilihandler = useCallback(async (type: any) => {
        const __val = u.getStatsParams(false, "", "", window.location.pathname);
        // req({ ...__val, category: "site", name: type ? "pic" : "cili" });
        if (process.env.NODE_ENV === "production") {
            const val = type ? "pic." : "download."
            let urlary = window.location.origin.split("https://") as any;
            if (urlary.length === 1) {
                urlary = window.location.origin.split("http://") as any;
            }
            if (urlary.length === 2) {
                urlary[0] = val;
            }
            urlary = urlary.join("").replace("www.", "");
            // const slash = urlary.lastIndexOf("/");
            // urlary = urlary.substring(0, slash);
            return u.open(`https://${urlary}`)
        }
        return u.open(type ? config?.pic_url : config?.cili_url)
    }, [])

    const routeToTopic = useCallback(async () => {
        return u.open("/topic")
    }, [])
    
    const toggleExpand = (id: number) => {
        setExpandedItemId(expandedItemId === id ? null : id);
    };

      const menuHandler = useCallback(
        async (type: string) => {
            const __val = u.getStatsParams(false, "", "", window.location.pathname);
    
            let categoryToSend;
            let name;
            
            // Set the category and name based on the type
            switch (type) {
                case "novel":
                    categoryToSend = "novel";
                    name = "成人小说";
                    break;
                case "pic":
                    categoryToSend = "pic";
                    name = "写真图库";
                    break;
                case "download":
                    categoryToSend = "cili";
                    name = "磁力资源";
                    break;
                case "luntan":
                    categoryToSend = "luntan";
                    name = "猫咪论坛";
                    break;
                default:
                    return;
            }
    
            // Request parameters
            req({ ...__val, category: categoryToSend, name });
    
            // Handle URL based on environment
            // if (process.env.NODE_ENV === "production") {
                const prefix = `${type}.`; // "novel.", "pic.", "download.", or "luntan."
                let urlary = window.location.origin.split("https://") as any;
                if (urlary.length === 1) {
                    urlary = window.location.origin.split("http://") as any;
                }
                if (urlary.length === 2) {
                    urlary[0] = prefix;
                }
                urlary = urlary.join("").replace("www.", "");
                return u.open(`https://${urlary}`);
            // }
    
            // Fallback URLs for development environment
            // switch (type) {
            //     case "novel":
            //         return u.open(config?.novel_url);
            //     case "pic":
            //         return u.open(config?.pic_url);
            //     case "download":
            //         return u.open(config?.cili_url);
            //     case "luntan":
            //         return u.open(config?.luntan_url);
            // }
        },
        []
    );

    return (
        <>
            <div onScroll={onScroll} className={`grid ${layoutStyles.layout}`}>
                <Header hideHead={hideHead} isScroll={!!isScroll} />
                {showCategory && <div className={`m0auto ${styles.ch}`}>
                    <div>
                        <div className={`${styles.banner_def} ${u.isPermenantVip() ? styles.banner_vip_def : ''}`}>
                            {!u.isPermenantVip() && <Slider />}
                        </div>
                        <div className={`grid ${layoutStyles.category}`}>
                            <Category showSiteCili={false} />
                            <div>
                                {<VipCard />}
                            </div>
                        </div>

                        {/* {siteTopic === '1' && 
                         <div className={`${styles.topic_banner}`} onClick={() => {
                                    routeToTopic()
                                }}>
                        <img className={`grid ${styles.banner}`} src={appendHost("/images/topic_banner.gif")} alt="" />
                        </div>
                        } */}
                       

                        {window.location.href.indexOf("topic") === -1 && <>
                            {getAddiotionalHideCondition() && <BannerList flag={flag} />}
                            {getAddiotionalHideCondition() && u.isMobile() && <RelateList />}
                        </>}
                       
                    </div>

                </div>}
                <div>
                    {children && children}
                </div>
            </div>
            <FastSection />
            <MsgModal />
            <Download />
        </>
    )
}
export default CategoryHead;